import { AppNS } from '..';
export const DOCUMENT_TYPES = [
  {
    id: 'qa_plan',
    title: 'Quality Assurance Plan',
    subtitle: 'Upload your quality assurance plan.',
  },
  {
    id: 'conflict_of_interest',
    title: 'Conflict of Interest Affidavit',
    subtitle: 'Upload your notarized, sworn Conflict of Interest Affidavit.',
  },
  {
    id: 'insurance',
    title: 'Insurance Policy',
    subtitle: 'Upload your Insurance Policy.',
  },
] as Array<{ id: AppNS.DocumentType; title: string; subtitle: string }>;
